<template>
  <div  v-if="this.params.data" style="text-align: right">
    {{ (this.params.data.Budget * (this.params.data.Probability / 100)).toFixed(2) }} €
  </div>
</template>